<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="100px">

				<el-row>
					<el-col :span="12">
						<el-form-item label="审视计划" prop="modeName">
							<!--未完成的审视计划下拉，session 记住  -->
							<el-input v-model="formParameter.modeName" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-show="false">
						<el-form-item label="bug待办" prop="springblogId"><el-input
								v-model="formParameter.springblogId"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>

					<el-col :span="12" v-show="false">
						<el-form-item label="归属sprint" prop="sprId">
							<!--未完成的审视计划下拉，默认当前+未开始sprint   session 记住  -->
							<el-input v-model="formParameter.sprId" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-show="false">
						<!--未完成的审视计划下拉，上面选中sprint 的 team members列表  -->
						<el-form-item label="团  队 " prop="teamId"><el-input v-model="formParameter.teamId"
								autocomplete="off"></el-input></el-form-item>
					</el-col>

				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="执行状态" prop="state">
							<select-option-dictionary v-model="formParameter.state"
								dkey="mt-state"></select-option-dictionary>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="计划开始" prop="pbgntm">
							<el-date-picker v-model="formParameter.pbgntm"
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
								placeholder="选择审视计划开始时间"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="计划完成" prop="pendtm">
							<el-date-picker v-model="formParameter.pendtm"
								value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
								placeholder="选择审视计划完成时间"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>

				<!-- 新增勾选框 -->
				<el-row>
					<el-col :span="12">
						<el-form-item label="添加会议">
							<el-checkbox v-model="includeMeeting">是否添加审视会议</el-checkbox>
						</el-form-item>
					</el-col>
				</el-row>

				<!-- 只有勾选后显示主持人和参与人 -->
				<el-row v-if="includeMeeting">
					<el-col :span="20">
						<el-form-item label="主持人">
							<el-select v-model="formParameter.host" @change="chgHost" autocomplete="off">
								<el-option v-for="item in teamMemberList" :key="item.id"
									:label="item.name" :value="item.name"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="includeMeeting">
					<el-col :span="20">
						<el-form-item label="参会人">
							<el-select v-model="participants" multiple filterable autocomplete="off">
								<el-option v-for="item in teamMemberList2" :key="item.id"
									:label="item.name" :value="item.name"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-show="editGoal">
					<el-col :span="24">
						<el-form-item label="审视计划描述" prop="need"><wang-edit :isupdt="isUpdtWedit"
								v-model="formParameter.need"></wang-edit></el-form-item>
					</el-col>
				</el-row>
				<el-row v-show="checkGoal">
					<el-col :span="4">
						<span>审视计划描述:</span>
					</el-col>
					<el-col :span="19">
						<span v-html="formParameter.need"></span>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确
				定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>

import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/sprint/survey/survey.js';
import wangEdit from '@/components/wangEdit/wangEdit.vue';
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";

export default {
	name: 'edit',
	components: {
		popup,
		wangEdit,
		selectOptionDictionary
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			sprId: '', //sprintId
			springblogId: '', //sprintBacklogid
			modeName: '',
			teamMemberList: [],
			teamMemberList2: [],  //参会人
			participants: [], //选中的参会人
			checkGoal: false,
			editGoal: false,
			includeMeeting: false, // 新增：是否添加审视会议的勾选框状态
			isUpdtWedit: false, //用于更新wangEdit
			upload: { //上传的信息
				fileSize: 10240, //限制文件大小
				myFileList: [], //上传的文件
			},
			path: '/statics/survey',
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {

			this.parameter = parameter;
			this.sprId = this.parameter.sprId;
			this.springblogId = this.parameter.springblogId;
			this.teamMemberList = this.parameter.teamMembers;
		
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//当更改文件时触发的方法，注意limit要开启大于1
		uploadChange(file, fileList) {
			if (file.size > this.upload.fileSize * 1024) {
				this.$message.warning(
					"图片尺寸不能大于" + this.upload.fileSize + "KB！"
				);
				let index = fileList.findIndex((item) => item.uid === file.uid);
				fileList.splice(index, 1);
			} else {
				this.upload.myFileList.push(file);
			}
		},
		uploadRemove(file, fileList) {
			let index = this.upload.myFileList.findIndex((fileItem) => {
				return fileItem.uid === file.uid;
			});
			this.upload.myFileList.splice(index, 1);
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();

			//清空旧值
			this.formParameter = {}
			this.isUpdtWedit = true
			setTimeout(() => {
				this.isUpdtWedit = false
			}, 100)
			this.$refs.popup.close();
		},close() {

			this.formParameter ={}
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			//判断一下文件是否大于0，否则不提交
			//console.log('length === ', this.upload.myFileList.length)
			//if (this.upload.myFileList.length <= 0) {
			//	this.$message.error('必须上传附件哦！');
			//	return;
			//}
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				//添加
				if (!this.parameter.id) {
					this.formParameter.sprId = this.sprId
					this.formParameter.springblogId = this.springblogId
					//处理参会人 
					let str = ""
					this.participants.forEach((v, i) => {
						str += v;
						if (i < (this.participants.length - 1)) {
							str += ","
						}
					});
					this.formParameter.participant = str
					api.save(this.formParameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();

							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);

					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		chgHost(val) {
			//reset
			this.participants = []
			//克隆
			this.teamMemberList2 = JSON.parse(JSON.stringify(this.teamMemberList))

			for (let i = 0; i < this.teamMemberList.length; i++) {
				if (val == this.teamMemberList[i].name) {
					this.teamMemberList2.splice(i, 1)
					break;
				}
			}

		},
		//当更改文件时触发的方法，注意limit要开启大于1
		uploadChange(file, fileList) {
			if (file.size > this.upload.fileSize * 1024) {
				this.$message.warning('图片尺寸不能大于' + this.upload.fileSize + 'KB！');
				let index = fileList.findIndex(item => item.uid === file.uid);
				fileList.splice(index, 1);
			} else {
				this.upload.myFileList.push(file);
			}
		},
		uploadRemove(file, fileList) {
			let index = this.upload.myFileList.findIndex(fileItem => {
				return fileItem.uid === file.uid
			});
			this.upload.myFileList.splice(index, 1);
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				if (this.disabled == true) {
					this.editGoal = false;
					this.checkGoal = true;
				} else {
					this.editGoal = true;
					this.checkGoal = false;
				}
				let parameter = {
					id: this.parameter.id
				};

				api.toUpdate(parameter, response => {
					this.formParameter = response.data;
					this.isUpdtWedit = true
					setTimeout(() => {
						this.isUpdtWedit = false
					}, 100)
					this.popupLoading = false;
				});
			} else {
				//添加
				this.editGoal = true;
				this.checkGoal = false;

				this.popupLoading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>